import { BASE_URL } from "../../constants/api";

export const Endpoint = {
  login: "/login",
  authenticated: "/authenticated-route",
  unauthenticated: "/unauthenticated-route",
  mimbox: "/mimbox",
  mimboxDemo: "/mimbox?demo=true",
  pdf: "/pdf",
};

interface ApiResponse {
  data?: {};
  status: number;
}

export class SimpleApi {
  baseUrl?: string;

  token?: string;

  logout?: Function;

  constructor(baseUrl = BASE_URL, token?: string, logout?: Function) {
    this.baseUrl = baseUrl;
    this.token = token;
    this.logout = logout;
  }

  setToken(token: string): void {
    this.token = token;
  }

  async call(
    endpoint: string,
    method = "GET",
    data?: {}
  ): Promise<{ data?: {}; status: number }> {
    try {
      const headers = new Headers({
        "Content-Type": "application/json",
      });
      if (this.token) {
        headers.set("Authorization", this.token);
      }
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        headers,
        method,
        body: JSON.stringify(data),
      });
      if (response.ok) {
        let responseData = await response.text();
        try {
          responseData = await JSON.parse(responseData);
        } catch {
          return { status: response.status };
        }
        return { data: responseData, status: response.status };
      }
      if (this.logout && response.status === 400) {
        this.logout();
      }
      return { status: response.status };
    } catch (error) {
      throw new Error("Something went wrong locally");
    }
  }

  login(username: string, password: string): Promise<ApiResponse> {
    return this.call(Endpoint.login, "POST", { username, password });
  }

  async getAuthenticatedData(): Promise<ApiResponse> {
    return this.call(Endpoint.authenticated, "GET");
  }

  async getMimboxData(demo: boolean): Promise<ApiResponse> {
    return demo
      ? this.call(Endpoint.mimboxDemo, "GET")
      : this.call(Endpoint.mimbox, "GET");
  }

  async getPdf(): Promise<ApiResponse> {
    return this.call(Endpoint.pdf, "POST");
  }
}
